export enum SPINNER {
  'SHOW_SPINNER' = '[SPINNER] SHOW_SPINNER',
  'HIDE_SPINNER' = '[SPINNER] HIDE_SPINNER'
}